// src/components/Avatar.tsx
import React from "react";
import { defaultAvatarFor } from "../utils/avatar-utils";

interface AvatarProps {
  name: string;
  size?: number;
  className?: string;
}

export default function Avatar({ name, size = 64, className = "" }: AvatarProps) {
  const src = defaultAvatarFor(name);
  const initials = name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");

  const [error, setError] = React.useState(false);

  if (error) {
    // fallback: initials on gradient circle
    return (
      <div
        className={`grid place-items-center rounded-full font-bold text-stone-800 ${className}`}
        style={{
          width: size,
          height: size,
          background:
            "radial-gradient(circle at 30% 30%, #f7d99c 0%, #e6b564 60%, #b88542 100%)",
          border: "2px solid #7b4a2a",
          fontSize: size * 0.36,
        }}
      >
        {initials || "?"}
      </div>
    );
  }

  const hasNoBorder = className.includes('border-0');
  return (
    <img
      src={src}
      alt={`${name} avatar`}
      width={size}
      height={size}
      draggable={false}
      onError={() => setError(true)}
      className={`rounded-full ${hasNoBorder ? '' : 'border-2 border-amber-900/40'} shadow-sm object-contain bg-transparent ${className.replace('border-0', '').trim()}`}
      style={{
        width: size,
        height: size,
      }}
    />
  );
}
